/*-------------------- gentleman-slider-section----------------------*/



class GentlemanSlider {
  constructor (parent) {
    if (!parent) {
      return;
    }
    this.parent = parent;
    this.slider();
    this.clickEvents();
  }

  slider = () => {
    let sliders = qsa('.gentleman-slider-js');
    sliders?.forEach(element => {
      
      let GentlemanSliderSlide = element.dataset.slide;
      let GentlemanSliderClass = element;
      this.GentlemanSlider(GentlemanSliderClass,GentlemanSliderSlide);
    });
  }

  clickEvents = () => {
    let parent = this.parent;
    let knowMoreBtns = qsa('.know-more-btn-js');
    knowMoreBtns?.forEach(element => {
      element?.addEventListener("click", (event) => {
        let dataIndex = element?.dataset?.sliderIndex;
        let popupSelector = qs(`.slider-popup-${dataIndex}-js`,parent);
        popupSelector?.classList.add('active-popup');
      });
    });
    
    let sliderPopupClose = qsa('.slider-popup-close-js',parent);
    sliderPopupClose?.forEach(closeBtn => {
      closeBtn.addEventListener("click", (e) => {
        let dataIndex = closeBtn?.dataset?.sliderIndex;
        let popupSelector = qs(`.slider-popup-${dataIndex}-js`,parent);
        popupSelector?.classList.remove('active-popup');
      });
    })

    let sliderArrow = qsa('.slider-arrow-js',parent);
    sliderArrow?.forEach(arrow => {
      arrow.addEventListener("click", (e) => {
        let popupSelector = qs('.active-popup',parent);
        popupSelector?.classList.remove('active-popup');
      });
    })
  }

  GentlemanSlider = (sliderClass) => {
    new Swiper(sliderClass, {
      loop: false,
      slidesPerView: 4,
      slidesPerGroup: 1,
      autoHeight:true,
      speed: 1000,
      spaceBetween: 20,
      breakpoints: {
        1: {
          slidesPerView: 1,
          spaceBetween: 60,
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 60,
        },
        1024: {
          slidesPerView: 1,
          spaceBetween: 60,
        },
      },

      // Navigation arrows
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
}

new GentlemanSlider(qs('.gentleman-slider-wrapper'));